export const Apiurl = "https://app.dialmantra.ca";
// export const Apiurl = 'http://192.168.12.18:800'
// export const Apiurl = 'https://test.collaberus.com:8000'
// export const Apiurl = 'https://demo.collaberus.com:8000'

export const ExcelDownloadFormat = "xlsx";
export const DateFormat = "DD-MM-YYYY";
